var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 2.7h-.4a1.8 1.8 0 0 0-1.8 1.8v.2a1.8 1.8 0 0 1-.9 1.55l-.4.24a1.8 1.8 0 0 1-1.8 0l-.15-.08a1.8 1.8 0 0 0-2.45.66l-.2.36a1.8 1.8 0 0 0 .66 2.45l.15.08a1.8 1.8 0 0 1 .9 1.56v.48a1.8 1.8 0 0 1-.9 1.56l-.15.09a1.8 1.8 0 0 0-.66 2.45l.2.36a1.8 1.8 0 0 0 2.45.66l.15-.08a1.8 1.8 0 0 1 1.8 0l.4.24a1.8 1.8 0 0 1 .9 1.55v.2a1.8 1.8 0 0 0 1.8 1.8h.4a1.8 1.8 0 0 0 1.8-1.8v-.2a1.8 1.8 0 0 1 .9-1.55l.4-.24a1.8 1.8 0 0 1 1.8 0l.15.08a1.8 1.8 0 0 0 2.45-.66l.2-.36a1.8 1.8 0 0 0-.66-2.45l-.15-.09a1.8 1.8 0 0 1-.9-1.56v-.48a1.8 1.8 0 0 1 .9-1.56l.15-.08a1.8 1.8 0 0 0 .66-2.45l-.2-.36a1.8 1.8 0 0 0-2.45-.66l-.15.08a1.8 1.8 0 0 1-1.8 0l-.4-.24a1.8 1.8 0 0 1-.9-1.55v-.2a1.8 1.8 0 0 0-1.8-1.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.96b944dcd6ab0199c8f6cc8a810006eb.svg";
export { ForwardRef as ReactComponent };